import { networkStore } from "../store/networkStore";
import { LoginServices } from "./LoginServices";
import { WhenDevelopment } from "../dev/WhenDevelopment";
import {sessionStore} from "../store/sessionStore";

const { response } = require("react");

const isHttps = window.location.origin.startsWith("https");
const apiUrl = WhenDevelopment.use(
  `${window.location.origin.replace("3000", isHttps ? "4444" : "8100")}/api/v1`,
  `${window.location.origin}/api/v1`
);

WhenDevelopment.run(() => {
  if (isHttps) {
    process.env.NODE_TLS_REJECT_ANAUTHORIZED = "0";
    console.log(
      "Https Agent: Reject Unauthorized is disabled in development mode"
    );
  }
});

class _NetworkService {
  _isOffline = false;

  async request({
    alias,
    url,
    method,
    data,
    params,
    headers,
    responseType = "application/json",
    ignoreUnauthorizedError = false,
  }) {
    const requestHeaders = {
      "Content-Type": "application/json",
      Accept: responseType,
      Authorization: sessionStore.token,
      ...headers,
    };

    this.startRequest(alias);

    try {
      const response = await fetch(`${apiUrl}/${url}`, {
        method,
        body: JSON.stringify(data),
        params,
        headers: requestHeaders,
      });

      if (!response.ok) {
        const error = new Error("Request failed: " + response.status);
        error.status = response.status;
        error.response = response;
        throw error;
      }

      if(responseType === "application/json"){
        let responseData;
        const responseBody = await response.text();
        try {
          responseData = JSON.parse(responseBody);
        } catch (jsonError) {
          responseData = responseBody;
        }

        this.stopRequest(alias);
        this._isOffline = false;
        return responseData;
      } else {
        return response;
      }
    } catch (reason) {
      const status = reason?.status || reason?.response?.status;
      if (status === 502) {
        this._isOffline = true;
      }

      if (status === 401 && !ignoreUnauthorizedError) {
        LoginServices.expireSession();
      }

      this.stopRequest(alias);
      console.error("Request failed", reason);

      throw reason;
    }
  }

  async requestMock({
    alias,
    url,
    method,
    data,
    params,
    headers,
    onUploadProgress,
  }) {
    return await new Promise((resolve) => {
      this.startRequest(alias);
      setTimeout(() => {
        this.stopRequest(alias);
        resolve(response);
      }, 5000);
    });
  }

  isOffiline() {
    return this._isOffline;
  }

  startRequest(request) {
    networkStore.requests.set(
      request,
      (networkStore.requests.get(request) || 0) + 1
    );
  }

  stopRequest(request) {
    networkStore.requests.set(
      request,
      (networkStore.requests.get(request) || 0) - 1
    );
  }

  async requestDownload({ url: fileUrl}) {
    try {
      const response = await fetch(`${apiUrl}/${fileUrl}`, {
        method: "GET",
        headers: {
          Authorization: sessionStore.token,
        },
        responseType: "text/csv",
      });

      if (!response.ok) {
        throw new Error("Failed to download file.");
      }

      const disposition = response.headers.get('content-disposition');
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      const filename = matches && matches[1] ? matches[1].replace(/['"]/g, '') : 'unknown.csv';

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Failed to download file:", error);
      throw error;
    }
  }

}

export const NetworkService = new _NetworkService();
